import { AnyAbility, PureAbility } from '@casl/ability';
import { store } from '../store';
import { Consumer, createContext } from 'react';
import { createContextualCan } from '@casl/react';

const storeData = store.getState();
const abilities = storeData.UserData ? storeData.UserData.abilities : [];

export default new PureAbility(abilities);

const AbilityContext = createContext({});
const Can = createContextualCan(AbilityContext.Consumer as Consumer<AnyAbility>);

export { AbilityContext, Can };
